import React, { useEffect, useState } from "react";
import http from "../lib/http";

export default function CategoryAdminPage() {

  const [categories, setCategories] = useState([]);

  const [form, setForm] = useState({
    name: "",
    editing: false,
    id: null,
  });

  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {

      const res = await http.get("/api/categories");

      setCategories(res.data);

    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);
    setMessage("");

    try {

      if (form.editing) {

        await http.put(`/api/categories/${form.id}`, {
          name: form.name,
        });

        setMessage("Category updated successfully");

      } else {

        await http.post("/api/categories", {
          name: form.name,
        });

        setMessage("Category added successfully");
      }

      setForm({
        name: "",
        editing: false,
        id: null,
      });

      fetchCategories();

    } catch (err) {

      console.error(err);

      setMessage(
        err?.response?.data?.msg || "Something went wrong"
      );

    } finally {

      setLoading(false);
    }
  };

  const handleEdit = (cat) => {

    setForm({
      name: cat.name,
      editing: true,
      id: cat._id,
    });
  };

  const handleDelete = async (id) => {

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?"
    );

    if (!confirmDelete) return;

    try {

      await http.delete(`/api/categories/${id}`);

      fetchCategories();

    } catch (err) {

      console.error("Delete failed:", err);

      alert("Failed to delete category");
    }
  };

  return (

      <div className="container-fluid">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">

          <div>
            <h2 className="fw-bold mb-1">
              Category Management
            </h2>

            <p className="text-muted mb-0">
              Manage dealer categories
            </p>
          </div>

          <div className="badge bg-primary p-3 fs-6 mt-2 mt-md-0">
            Total Categories: {categories.length}
          </div>

        </div>

        {/* Form Card */}
        <div className="card shadow-sm border-0 mb-4">

          <div className="card-body">

            <form onSubmit={handleSubmit}>

              <div className="row g-3 align-items-center">

                <div className="col-md-9">

                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Enter category name"
                    value={form.name}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        name: e.target.value,
                      })
                    }
                    required
                  />

                </div>

                <div className="col-md-3 d-grid">

                  <button
                    className={`btn btn-lg ${
                      form.editing
                        ? "btn-warning"
                        : "btn-primary"
                    }`}
                    disabled={loading}
                  >
                    {loading
                      ? "Please wait..."
                      : form.editing
                      ? "Update Category"
                      : "Add Category"}
                  </button>

                </div>

              </div>

              {form.editing && (

                <div className="mt-3">

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() =>
                      setForm({
                        name: "",
                        editing: false,
                        id: null,
                      })
                    }
                  >
                    Cancel Editing
                  </button>

                </div>
              )}

            </form>

            {message && (

              <div className="alert alert-info mt-3 mb-0">
                {message}
              </div>

            )}

          </div>

        </div>

        {/* Category List */}
        <div className="card shadow-sm border-0">

          <div className="card-body">

            <h5 className="fw-bold mb-4">
              Category List
            </h5>

            {categories.length === 0 ? (

              <div className="text-center py-5 text-muted">
                No categories available
              </div>

            ) : (

              <div className="table-responsive">

                <table className="table align-middle">

                  <thead className="table-light">

                    <tr>
                      <th>#</th>
                      <th>Category Name</th>
                      <th className="text-center">
                        Actions
                      </th>
                    </tr>

                  </thead>

                  <tbody>

                    {categories.map((cat, index) => (

                      <tr key={cat._id}>

                        <td>{index + 1}</td>

                        <td className="fw-semibold">
                          {cat.name}
                        </td>

                        <td>

                          <div className="d-flex gap-2 justify-content-center flex-wrap">

                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => handleEdit(cat)}
                            >
                              Edit
                            </button>

                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() =>
                                handleDelete(cat._id)
                              }
                            >
                              Delete
                            </button>

                          </div>

                        </td>

                      </tr>

                    ))}

                  </tbody>

                </table>

              </div>

            )}

          </div>

        </div>

      </div>

  );
}